export default __webpack_public_path__ + "static/media/arrow_dn.6bf2f0a4.png";